const animationDuration = 4000;
const frameDuration = 1000 / 60;
const totalFrames = Math.round( animationDuration / frameDuration );
const easeOutQuad = t => t * ( 2 - t );

const animateCountUp = el => {
	let frame = 0;
	const countTo = parseInt( el.dataset.countUp, 10 );
	const counter = setInterval( () => {
		frame++;
		const progress = easeOutQuad( frame / totalFrames );
		const currentCount = Math.round( countTo * progress );
		if ( parseInt( el.innerHTML, 10 ) !== currentCount ) {
			el.innerHTML = '£' + currentCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}
		if ( frame === totalFrames ) {
			clearInterval( counter );
		}
	}, frameDuration );
};


const runAnimations = () => {
	const countupEls = document.querySelectorAll( '[data-count-up]' );
	countupEls.forEach( animateCountUp );
};


const countUpElement = document.querySelector('[data-count-up]');
const yourFunction = () => {
  runAnimations();
  observer.unobserve(countUpElement);
};

const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      yourFunction();
    }
  });
}, { threshold: 0.1 }); 

observer.observe(countUpElement);